import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { GroupSC } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/recipient.types';
import { MultiSelect } from 'primereact/multiselect';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

interface ScGroupFieldProps {
  control: Control<NewMessageFormData>;
  t: (key: string) => string;
  styles: Record<string, string>;
  groupSCOptions: {
    name: string;
    value: GroupSC;
  }[];
}

const ScGroupField: FC<ScGroupFieldProps> = ({ control, t, styles, groupSCOptions }) => (
  <div className={styles['form-section']}>
    <label>{t('messages.mailbox.recipientTypes.scGroup.label')}</label>
    <Controller
      name="gsc"
      control={control}
      rules={{ required: t('common.validation.fieldRequired') }}
      render={({ field, fieldState }) => (
        <>
          <MultiSelect
            value={field.value}
            options={groupSCOptions}
            onChange={(e) => field.onChange(e.value)}
            optionLabel="name"
            placeholder={t('messages.mailbox.recipientTypes.scGroup.description')}
            display="chip"
            className={`w-full ${fieldState.invalid ? 'p-invalid' : ''}`}
          />
          {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
        </>
      )}
    />
  </div>
);

export default ScGroupField;
